<template>
  <div>
    <div class="custom-carousel">
      <PCarousel
        ref="carousel"
        :autoplay-interval="3_000"
        :num-scroll="1"
        :num-visible="1"
        :show-indicators="false"
        :value="banners"
        circular
      >
        <template #item="slotProps">
          <component :is="slotProps.data.component()" />
        </template>
      </PCarousel>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, ref, shallowRef } from 'vue';
import { AirdropBanner } from '@/components/UI/Banners/AirdropBanner';
import { DownloadWalletBanner } from '@/components/UI/Banners/DownloadWalletBanner';
import { ReturdBanner } from '@/components/UI/Banners/ReturdBanner';
import { DooDooBanner } from '@/components/UI/Banners/DooDooBanner';
import { FarmBanner } from '@/components/UI/Banners/FarmBanner';
import { LumioBanner } from '@/components/UI/Banners/LumioBanner';
import { UptosBanner } from '@/components/UI/Banners/UptosBanner';
import { DashboardBanner } from '@/components/UI/Banners/DashboardBanner';
import { DonkBanner } from '@/components/UI/Banners/DonkBanner';
import { HairtokenBanner } from '@/components/UI/Banners/HairtokenBanner';
import { MoomooBanner } from '@/components/UI/Banners/MoomooBanner';
import { WormholeBanner } from '@/components/UI/Banners/WormholeBanner';
import { ChainsEnum, CORRECT_CHAIN } from '@/constants';

const carousel = ref(null);

const isMovement = computed(() =>
  [ChainsEnum['movement-testnet'], ChainsEnum['movement-mainnet']].includes(
    CORRECT_CHAIN.id,
  ),
);

const movementBanners = shallowRef([]);

const bannersArray = shallowRef([
  WormholeBanner,
  MoomooBanner,
  HairtokenBanner,
  DonkBanner,
  AirdropBanner,
  LumioBanner,
  DashboardBanner,
  UptosBanner,
  ReturdBanner,
  FarmBanner,
  DooDooBanner,
  DownloadWalletBanner,
]);

const banners = computed(() =>
  (isMovement.value ? movementBanners : bannersArray).value.map(
    (banner, index) => ({
      id: index,
      component: () => banner,
    }),
  ),
);
</script>

<style lang="scss" scoped>
::v-deep(.custom-carousel) {
  .p-carousel-next {
    margin: 0 0 0 5px;
    width: 32px;
    height: 84px;
    border-radius: 10px;
    background: #abaeff21;
    &:focus {
      box-shadow: none;
    }
  }
  .p-carousel-prev {
    margin: 0 5px 0 0;
    width: 32px;
    height: 84px;
    border-radius: 10px;
    background: #abaeff21;
    &:focus {
      box-shadow: none;
    }
  }
}
</style>
